import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { API, CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, Event as NavigationEvent } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { StorageService } from 'src/app/core/services/storage.service';
import { filter, map, startWith } from 'rxjs/operators';
import { UpdatePaymentDialog } from '../ic-header/ic-header.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Console, log } from 'console';
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { sortGroupsAlphabetically } from 'src/app/core/utils/sort-groups.util';

declare let $: any;

@Component({
  selector: 'app-ic-home',
  templateUrl: './ic-home.component.html',
  styleUrls: ['./ic-home.component.scss']
})
export class ICHomeComponent implements OnInit {
  streamAdsData: any;
  sponsorData: any;
  streamingData: any;
  displayName: any;
  performerInfo: any;
  userInfo: any = {};
  deviceData: Subscription;
  liveEventSubscr: Subscription;
  @ViewChild('widgetsContent', { static: false }) widgetsContent: ElementRef;
  @ViewChild('groupRow', { static: false }) groupRow: ElementRef<HTMLElement>;
  icWebpageSettingsData: any = {};
  userInfoSubscription: Subscription;
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  org_info: any = {};
  performerInfoSubscr: Subscription;
  subscriberDataSub: Subscription;
  subscribedPlanData: any;
  performer_bio: any;
  subscribedUserPlans: any = [];
  deviceType: any;
  channelName: any = "";
  groupName: any = "";
  closeButton: boolean;
  centerAds: any[];
  showTimer: boolean;
  rightAds: any;
  org_id: any;
  subChannelsList: any = [];
  isNetworkChannel: boolean = false;
  showSubChannelLeftButton: boolean = false;
  showSubChannelRightButton: boolean = true;
  currentTheme: any;
  preloadAdsdata: any[];
  eventHomeAdsTop: any[];
  adVideo: any;
  browserButtonBackForwSubscription: Subscription;
  // Resyncs groupName/activeGroupData from the URL for any navigation trigger (not just
  // popstate above) - fixes the dashboard/agent's own "Groups" chip (ai-agent.component.ts
  // selectGroup()) only calling router.navigateByUrl() without updating this component's
  // local group state, which the default route-reuse strategy leaves stale since :channelName
  // and :channelName/:groupName share this same component instance across group switches.
  // Self-dedupes against the popstate handler and goToGroup() via the groupName comparison,
  // since both already update this.groupName synchronously before the router event lands here.
  groupSyncOnNavSubscription: Subscription;
  webChannelName: any;
  groups: any[] = [];
  groupsLabel: string = 'Group';
  groupId = 0;
  planGroupMap: Map<number, number> = new Map();
  groupTints: Map<string, string | null> = new Map();
  private homeGroupsCache: { groups: any[]; slug: string; result: any[] } = null;
  private groupRowSlug: string = null;
  private networkTileCache: { org: any; tile: any } = null;
  activeGroupData: any = null;
  defaultOrgData: any;
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.code == "ArrowRight") {
      this.scrollRight();
    }
    if (event.code == "ArrowLeft") {
      this.scrollLeft();

    }
  }
  constructor(public router: Router,
    private route: ActivatedRoute,
    private commanSubscribeService: CommanSubscribeService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    public sanitizer: DomSanitizer,
    private commonSubscribeService: CommanSubscribeService,
    private appService: AppService,
    private storageService: StorageService,
    private changeDetector: ChangeDetectorRef,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private titleService: Title) {

    this.browserButtonBackForwSubscription = router.events.pipe(filter(
      (event: NavigationEvent) => {
        return (event instanceof NavigationStart);
      }
    ))
      .subscribe(
        (event: NavigationStart) => {
          if (event.navigationTrigger === "popstate" && event.url) {
            if (event.url && event.url.includes('/channel/')) {
              let urlArray = event.url.split('/channel/')[1];
              if (urlArray.includes('/')) {
                if (urlArray.includes('/preview?')) {
                  let split = urlArray.split("/")[0];
                  this.webChannelName = split;
                } else {
                  let split = urlArray.split("/")
                  this.webChannelName = split[split.length - 1];
                }
              } else if (urlArray.includes('?')) {
                let split = urlArray.split("?")[0];
                this.webChannelName = split;
              } else {
                this.webChannelName = urlArray;
              }
            }

            // Extract groupName from URL segments: /:channelName/:groupName/...
            const pathSegments = event.url.split('?')[0].split('/').filter(s => s !== '');
            const urlGroupSlug = pathSegments.length >= 2 && !pathSegments[1].includes('channel') ? pathSegments[1] : '';
            if (urlGroupSlug !== this.groupName) {
              this.groupName = urlGroupSlug;
              if (urlGroupSlug && this.groups?.length > 0) {
                const matched = this.groups.find(g => g.group_slug === urlGroupSlug);
                if (matched) {
                  this.activateGroup(matched);
                }
              } else if (!urlGroupSlug) {
                this.groupName = '';
                this.groupId = 0;
                this.activeGroupData = null;
                this.commanSubscribeService.setActiveGroup({ group_slug: '', id: 0 });
                this.generList = [];
                this.upCommingEventList = [];
                this.pastEvents = [];
                this.org_info = { ...this.defaultOrgData };
              }
              this.getChannelHome();
            }

            this.commanSubscribeService.getWebPageSettings(this.webChannelName, true);
          }
        }
      );

    this.groupSyncOnNavSubscription = router.events.pipe(filter(
      (event: NavigationEvent) => event instanceof NavigationEnd
    )).subscribe(
      (event: NavigationEnd) => {
        const pathSegments = event.urlAfterRedirects.split('?')[0].split('/').filter(s => s !== '');
        const urlGroupSlug = pathSegments.length >= 2 && !pathSegments[1].includes('channel') ? pathSegments[1] : '';
        if (urlGroupSlug !== this.groupName) {
          if (urlGroupSlug && this.groups?.length > 0) {
            const matched = this.groups.find(g => g.group_slug === urlGroupSlug);
            if (matched) {
              this.activateGroup(matched);
            }
          } else if (!urlGroupSlug) {
            this.groupName = '';
            this.groupId = 0;
            this.activeGroupData = null;
            this.commanSubscribeService.setActiveGroup({ group_slug: '', id: 0 });
            this.generList = [];
            this.upCommingEventList = [];
            this.pastEvents = [];
            this.org_info = { ...this.defaultOrgData };
          }
          this.getChannelHome();
        }
      }
    );
  }

  appType: any;
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
      this.showScroll = true;
    }
    else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
      this.showScroll = false;
    }
  }
  ngOnInit() {
    // ngOnInit is re-run after sign-in; drop the previous run's subscriptions so handlers don't stack up.
    [this.deviceData, this.userInfoSubscription, this.settingsDataSubscription,
      this.subscriberDataSub, this.performerInfoSubscr].forEach(sub => sub?.unsubscribe());
    if (this.router.url.includes('/channel/')) {
      this.isNetworkChannel = false;
    } else {
      this.isNetworkChannel = true;
    }
    this.currentTheme = this.commanSubscribeService.getThemeColors();
    this.deviceType = this.commanSubscribeService.deviceType;
    this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    })
    this.appType = this.storageService.getItem('app_type');
    this.imageScroll()
    this.userInfo = this.commanSubscribeService.userInfo;
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (this.userInfo && !this.userInfo.access_token) {
        this.userInfo = {};
      }
      //console.log(this.userInfo,this.userInfo.access_token)
    });

    if (this.activatedRoute.snapshot.params.channelName) {
      this.channelName = this.activatedRoute.snapshot.params.channelName;
      if (this.channelName[this.channelName.length - 1] == "#") {
        this.channelName = this.channelName.slice(0, -1);
      }
    }
    if (this.activatedRoute.snapshot.params.groupName) {
      this.groupName = this.activatedRoute.snapshot.params.groupName;
      this.commanSubscribeService.activeGroupSlug = this.groupName;
    } else {
      this.groupName = '';
      this.activeGroupData = null;
      this.commanSubscribeService.setActiveGroup({ group_slug: '', id: 0 });
    }

    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      this.checkIsSubscribed(this.subscribedUserPlans);
      if (!this.settingsData.is_preview) {
        this.getChannelHome();
      } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
        this.getChannelInfo();
      } else {
        this.getChannelHome();
      }
      const showSignIn = this.route.snapshot.data['showSignIn'];
      const returnUrl = this.route.snapshot.queryParams['returnUrl'];
      const isUserLoggedIn = this.userInfo && 
                            this.userInfo.access_token && 
                            Object.keys(this.userInfo).length > 0;

      if (showSignIn && !isUserLoggedIn) {
        if (!this.router.url.includes("/sign-up")) {
          this.storageService.setItem("skipRedirection", "yes");
        }
        const dialogRef = this.dialog.open(ConsumerSignInComponent, {
          maxWidth: "450px",
          id: "mat-box",
          panelClass:
            Object.keys(this.settingsData).length > 0 &&
            this.settingsData.form_bg_color
              ? "app-consumer-signin"
              : "app-consumer-sign-in",
          disableClose: true,
          data: {},
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result == "success") {
            this.userInfo = this.commanSubscribeService.userInfo;
            this.ngOnInit();
          }

          if (!this.router.url.includes("/sign-up")) {
            this.storageService.deleteItem("skipIcRedirection");
          }
        });
      }
    });

    if (Object.keys(this.settingsData).length > 0) {
      document.body.classList.add("home");
    }
    this.subscribedUserPlans = this.commanSubscribeService.subscribePayedInfoData;
    this.checkIsSubscribed(this.subscribedUserPlans);
    // if(subscribedData.length>0){
    // this.subscribedPlanData = subscribedData.data.Subscription_details
    // console.log(subscribedData)
    // }
    this.subscriberDataSub = this.commanSubscribeService.getSubscribePayedInfo().subscribe(response => {
      this.subscribedUserPlans = response;
      this.checkIsSubscribed(this.subscribedUserPlans);
    })
    let perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.performerInfoSubscr = this.commanSubscribeService.getPerfomerInfo().subscribe(response => {
      this.getPerformerInfo(response);
    })
    if (Object.keys(perfomerInfoData).length > 0) {
      this.getPerformerInfo(perfomerInfoData);
    }
  }

  activateGroup(group: any): void {
    this.groupId = group.id;
    this.groupName = group.group_slug;
    this.activeGroupData = group;
    this.generList = [];
    this.upCommingEventList = [];
    this.pastEvents = [];
    this.subChannelsList = [];
    if (this.groupName) {
      this.org_info = {
        ...this.org_info,
        channel_banner: group?.group_banner || this.defaultOrgData?.channel_banner,
      };
    }
    this.commanSubscribeService.setActiveGroup(group);
  }

  // Name shown on a logo-less group/sub-channel card sits on the card's own background
  // (.video-c-img is a fixed #000000 unless the card sets one), so the theme's secondary
  // font color is kept only when it contrasts with that background; otherwise black/white.
  getCardTitleColor(cardBg?: string): string | null {
    const font = this.settingsData?.font_secondary_color || null;
    const bgLuminance = this.getLuminance(cardBg || '#000000');
    if (bgLuminance === null) return font;
    const fontLuminance = this.getLuminance(font);
    if (!font || (fontLuminance !== null && Math.abs(bgLuminance - fontLuminance) < 0.35)) {
      return bgLuminance < 0.5 ? '#ffffff' : '#000000';
    }
    return font;
  }

  // 0 (black) to 1 (white); null when the color isn't a 6-digit hex we can measure.
  private getLuminance(color: string | null): number | null {
    const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color || '');
    if (!match) return null;
    const [r, g, b] = match.slice(1).map(h => parseInt(h, 16));
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  // Home groups row shows the current group first, then the rest A-Z. Display order only: `groups` itself keeps its
  // API order since other lookups use it. Cached so change detection gets the same array back.
  get homeGroups(): any[] {
    const groups = this.groups || [];
    const cache = this.homeGroupsCache;
    if (cache && cache.groups === groups && cache.slug === this.groupName) return cache.result;
    const active = groups.find(g => g.group_slug === this.groupName);
    const rest = sortGroupsAlphabetically(active ? groups.filter(g => g !== active) : groups);
    const result = active ? [active, ...rest] : rest;
    this.homeGroupsCache = { groups, slug: this.groupName, result };
    return result;
  }

  // Tile for the network itself, always first in the Home groups row: marked as selected while on
  // the network, and a way back to it while a group is selected. Name/logo come from the network's own org_info (defaultOrgData), not the
  // group-overridden org_info. Cached so change detection gets the same object back.
  get networkTile(): any {
    const org = this.defaultOrgData;
    if (!org) return null;
    if (this.networkTileCache?.org !== org) {
      this.networkTileCache = {
        org,
        tile: {
          name: org.organization_name,
          group_logo: org.channel_logo || org.organization_logo,
          group_slug: '__network__'
        }
      };
    }
    return this.networkTileCache.tile;
  }

  // Back to the network-wide home. The NavigationEnd handler in the constructor clears the rest of
  // the group state and reloads the home data for a bare channel URL (same route the agent's "All"
  // chip uses). The shared active group is cleared first, as goToGroup() sets it first, so the
  // settings request below loads the network's own theme instead of the group's.
  goToNetwork(): void {
    if (!this.groupName) return;
    this.commanSubscribeService.setActiveGroup({ group_slug: '', id: 0 });
    this.commanSubscribeService.getCartProdCountApiCallSubject.next(true);
    this.router.navigate(['/' + this.channelName]);
    this.commanSubscribeService.getWebPageSettings(this.webChannelName, true);
  }

  // The current group moves to the front of the Home groups row, so bring the row back to the
  // start whenever the selection changes; otherwise the new first tile can sit off-screen.
  private resetGroupRowScroll(): void {
    if (!this.groupRow || this.groupRowSlug === this.groupName) return;
    this.groupRowSlug = this.groupName;
    this.groupRow.nativeElement.scrollTo({ left: 0, behavior: 'smooth' });
  }

  // Shown in place of a missing logo on a Home group tile: first letters of the first two words
  // ("Team USA" -> "TU"), or the first letter of a one-word name.
  getGroupInitials(name: string): string {
    const words = (name || '').trim().split(/\s+/).filter(w => w);
    if (!words.length) return '?';
    return words.slice(0, 2).map(w => w.charAt(0)).join('').toUpperCase();
  }

  // Genre items with no thumbnail get audio_default_image.png substituted in getHomeDetails(); the
  // card shows a type-aware fallback instead, so a video without a thumbnail doesn't look like audio.
  hasOwnThumbnail(item: any): boolean {
    const src: string = item?.video_thumbnail_image || '';
    return !!src && !src.endsWith('audio_default_image.png');
  }

  // Drives the genre card's type icon and fallback: audio, or video for video/recorded-video.
  getMediaType(item: any, row?: any): 'audio' | 'video' {
    return (item?.tag_category || row?.tag_category) === 'audio' ? 'audio' : 'video';
  }

  // Background tint for a Home group tile: the logo's average colour (weighted by saturation so
  // colourful pixels win over plain backgrounds). null until sampled, and stays null when there's
  // no logo or the logo host blocks canvas reads via CORS; the tile then uses its neutral default.
  getGroupTint(group: any): string | null {
    const key = group?.group_slug || group?.name || '';
    if (!this.groupTints.has(key)) {
      this.groupTints.set(key, null);
      if (group?.group_logo) this.sampleLogoTint(key, group.group_logo);
    }
    return this.groupTints.get(key);
  }

  private sampleLogoTint(key: string, src: string): void {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 24;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, 24, 24);
        const d = ctx.getImageData(0, 0, 24, 24).data;
        let r = 0, g = 0, b = 0, w = 0;
        for (let i = 0; i < d.length; i += 4) {
          const s = Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2]) + 8;
          r += d[i] * s; g += d[i + 1] * s; b += d[i + 2] * s; w += s;
        }
        this.groupTints.set(key, `rgb(${Math.round(r / w)}, ${Math.round(g / w)}, ${Math.round(b / w)})`);
      } catch {
        // Logo host without CORS headers taints the canvas; the tile keeps its neutral default.
      }
    };
    img.src = src;
  }

  // Upcoming event cards show the title's first letter instead of the banner when the banner is
  // missing, fails to load (the template's (error) sets the flag), or is blank.
  checkEventBanner(event: any): void {
    event.bannerFallback = !event.event_home_banner;
    if (!event.bannerFallback) this.sampleBannerBlank(event);
  }

  getEventInitial(event: any): string {
    const title: string = (event?.stream_info?.stream_video_title || '').trim();
    return title ? title.charAt(0).toUpperCase() : '?';
  }

  // A banner counts as blank when nearly every sampled pixel is black or transparent. When the
  // banner host blocks canvas reads via CORS the banner is shown as-is.
  private sampleBannerBlank(event: any): void {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 24;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, 24, 24);
        const d = ctx.getImageData(0, 0, 24, 24).data;
        let blank = 0;
        for (let i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 24 || Math.max(d[i], d[i + 1], d[i + 2]) < 24) blank++;
        }
        if (blank / (d.length / 4) > 0.95) event.bannerFallback = true;
      } catch {
        // Tainted canvas (no CORS headers): keep showing the banner.
      }
    };
    img.src = event.event_home_banner;
  }

  goToGroup(group: any): void {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Group is clicked: ${group.name} ${group.id} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Group is clicked: ${group.name} ${group.id}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      networkGroupId : group?.id || null,
      clickAction: 'group-clicked'
    };
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    this.activateGroup(group);
    this.commanSubscribeService.getCartProdCountApiCallSubject.next(true);
    this.router.navigate(['/' + this.channelName + '/' + group.group_slug]);
    this.commanSubscribeService.getWebPageSettings(this.webChannelName, true, group);
    if (!this.settingsData.is_preview) {
      this.getChannelHome();
    } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
      this.getChannelInfo();
    } else {
      this.getChannelHome();
    }
  }

  getPerformerInfo(response) {

    // let data = {
    //   headers: {
    //     "Content-Type": "application/json",
    //     "x-api-key": environment.AWS_Cognito.X_Api_Key,
    //     "Authorization": `Bearer ${this.userInfo.access_token}`
    //   },
    //   response: true,
    //   body: {
    //     "channel_name": this.channelName
    //   }
    // }
    // this.ngxLoader.start();
    // API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
    //   this.ngxLoader.stop();

    if (response && response.data && response.data.statusCode === '200') {
      this.titleService.setTitle(response.data.Data[0]?.channel_display_name);
      console.log("pagetitle", response, response.data.Data[0]?.channel_display_name);
      this.groups = response.data.Data[0]?.groups;
      this.groupsLabel = response.data.Data[0]?.network_type_label || 'Group';
      this.planGroupMap = new Map();
      (response.data.Data[0]?.plans || []).forEach((p: any) => this.planGroupMap.set(p.id, p.network_group_id || 0));
      (this.groups || []).forEach((g: any) => (g.plans || []).forEach((p: any) => this.planGroupMap.set(p.id, p.network_group_id || 0)));
      if (this.groupName && this.groups?.length > 0) {
        const matched = this.groups.find(g => g.group_slug === this.groupName);
        if (matched) {
          this.activateGroup(matched);
        }
      }
      this.org_id = (response.data.Data && response.data.Data[0]) ? response.data.Data[0].org_info.id : null;
      this.performerInfo = (response.data.Data && response.data.Data[0]) ? response.data.Data[0].performer_details : null;
      if (this.performerInfo) {
        this.performerInfo.performer_profile_banner = this.performerInfo.performer_profile_banner ? this.performerInfo.performer_profile_banner : DEFAULT_IMAGE.IMAGE_2;
      }
      if (response.data.Data && response.data.Data[0] && response.data.Data[0].org_info) {
        this.defaultOrgData = { ...response.data.Data[0].org_info };
        this.defaultOrgData.channel_banner = this.defaultOrgData.channel_banner || this.defaultOrgData.organization_banner || DEFAULT_IMAGE.IMAGE_2;
        this.org_info = { ...this.defaultOrgData };
        if (this.org_info && this.org_info.vod_site_id) {
          this.getAds();
        }
      }
      if (this.groupName && this.groups?.length > 0) {
        const matched = this.groups.find(g => g.group_slug === this.groupName);
        if (matched) {
          this.activateGroup(matched);
        }
      }

      //console.log(response.data.Subscription_details , this.userInfo , this.userInfo.access_token)
      if (response.data.Subscription_details && this.userInfo && this.userInfo.access_token) {
        this.subscribedUserPlans = response.data.Subscription_details;
        let val = this.storageService.getItem('popup');
        let checkStatus = this.subscribedUserPlans.filter(e => e.payment == 'success');
        if (this.subscribedUserPlans && this.subscribedUserPlans[0]) {
          if (checkStatus.length == 0 && !val) {
            const dialogRef = this.dialog.open(UpdatePaymentDialog, {
              maxWidth: "700px",
              panelClass: 'ios-modal',
              disableClose: true,
              data: this.channelName
            });
            dialogRef.afterClosed().subscribe(result => {
              this.storageService.setItem('popup', true);
            });
          }
        }
        this.checkIsSubscribed(this.subscribedUserPlans);
      }
      if (Object.keys(this.settingsData).length > 0) {
        if (!this.settingsData.is_preview) {
          if(!this.groupName) {
            this.org_info = { ...this.defaultOrgData };
          }
          this.getChannelHome();
        } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
          this.getChannelInfo();
        } else {
          this.getChannelHome();
        }
      }
    }

    // }).catch(error => {
    //   this.ngxLoader.stop();
    // });

  }

  getChannelInfo() {
    let data = { "token": this.activatedRoute.snapshot.queryParams.token };
    this.ngxLoader.start();
    this.appService.postRequest(API.CHANNEL_HOME, data).subscribe(response => {
      this.ngxLoader.stop();
      if (response.statusCode === 200) {
        console.log(response, "::::::::>>>>>>>>")
        this.getHomeDetails(response, 'preview');
        this.getSubChannelsDetails(response['sub_channels'])
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  upCommingEventList: any = [];
  generList: any = [];
  assets_url = environment.assets_url;
  subChannelInfo: any;
  channelHomeRequestKey: string = null;
  getChannelHome() {
    //console.log("SETTINGS DATA: ", this.settingsData)
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        performer_id: this.performerInfo ? this.performerInfo.user_id : null,
        organization_id: this.org_id,
        channel_id: this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id && this.router.url.includes('/channel/') ? this.settingsData.channelInfo.channel_id : 0,
        // performer_id: 52
        network_group_id: this.groupId || 0,
        // network_group_category_id: [25],
        // network_sport_id: [13,14]
      }
    }
    // Several triggers (settings, performer info, navigation) can fire together; an identical request
    // already in flight will render the same data, since its handler reads current state on arrival.
    const requestKey = JSON.stringify(data.body) + '|' + (this.userInfo.access_token || '');
    if (requestKey === this.channelHomeRequestKey) {
      return;
    }
    this.channelHomeRequestKey = requestKey;
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_CHANNEL_HOME, data).then(response => {
      this.channelHomeRequestKey = null;
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        this.commanSubscribeService.trackGoogleAnalytics('open_app');
        this.commanSubscribeService.trackFBEvents('OpenApp');
        this.getHomeDetails(response);
        if (response['data']['sub_channels'].length > 0) {
          let subChannels = response['data']['sub_channels'];
          subChannels.forEach(element => {
            if (this.activatedRoute.snapshot.params['sub-channel'] == element.channel_name) {
              this.subChannelInfo = element;
            }
            if (this.activatedRoute.snapshot.params['sub-channel'] == element.channel_name && element.status == 0) {
              this.toastr.info(`Currently ${this.activatedRoute.snapshot.params['sub-channel']} channel is not available, please try again later`);
              this.router.navigate(['/' + this.channelName]);
            }
          });
        }
        if (!this.router.url.includes('/channel/')) {
          this.getSubChannelsDetails(response['data']['sub_channels'])
          this.commanSubscribeService.getWebPageSettings(0);
        }
        const matched = this.groups.find(g => g.group_slug === this.groupName);
        if (matched) {
          this.org_info = {
            ...this.org_info,
            channel_banner: matched?.group_banner || this.defaultOrgData?.channel_banner,
          };
        }
        // else
        // this.commanSubscribeService.getWebPageSettings(this.activatedRoute.snapshot.params['sub-channel'], true);
      }
    }).catch(error => {
      this.channelHomeRequestKey = null;
      this.ngxLoader.stop();
    });
  }

  getSubChannelsDetails(subChannels: any) {
    this.subChannelsList = [];
    subChannels.forEach(element => {
      if (element.status == 1) {
        if (this.settingsData.main_bg_color == this.settingsData.bg_secondary_color) {
          if (this.settingsData.main_bg_color == this.currentTheme.primaryFontColor) {
            element.cardBackgroundColor = this.currentTheme.tertiaryColor + "85";
          } else {
            element.cardBackgroundColor = this.currentTheme.primaryFontColor;
          }
        } else {
          element.cardBackgroundColor = this.settingsData.main_bg_color
        }
        this.subChannelsList.push(element);
        console.log(this.activatedRoute.snapshot, "::::::::>>>>>>>>")
      }
      if (this.activatedRoute.snapshot.params['subChannelName'] == element.channel_name) {
        this.subChannelInfo = element;
      }
    });
  }

  currentLocation: any = {};
  pastEvents: any = [];
  getHomeDetails(response, from?) {

    this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
      if (val == "fail") {
        this.currentLocation = {};
      } else {
        this.currentLocation = json;
      }

      this.upCommingEventList = from ? response.events || [] : response.data.events || [];
      this.pastEvents = from ? response.past_events || [] : response.data.past_events || [];
      this.upCommingEventList.forEach(e => {
        if (e.stream_info.media_files) {
          let media_files = JSON.parse(e.stream_info.media_files);
          Object.keys(media_files).forEach(element => {
            e[element] = media_files[element];
          });
        }
        this.checkEventBanner(e);
      });
      this.generList = from ? response.Data : response.data.Data;
      if (this.generList && this.generList.length > 0) {
        this.generList.forEach(e => {
          e.seeAll = false;
          e.righthide = false;
          e.lefthide = false;
          //console.log(e.data.length) 
          if (e.data && e.data.length > 0) {
            let filterData = [];
            e.data.forEach(e1 => {
              if (!e1.video_thumbnail_image) {
                e1.video_thumbnail_image = this.assets_url + "audio_default_image.png";
              }

              if (e1.additional_info) {
                let additional_info = JSON.parse(e1.additional_info);
                if (!additional_info.geo_block || additional_info.geo_block.includes("all") || additional_info.geo_block.includes(this.currentLocation.country_code2)) {
                  filterData.push(e1);
                }
              } else {
                filterData.push(e1);
              }
            });
            e.data = filterData;
          }
          if (e.data && e.data.length > 0) {
            e.data.push({ name: 'seeall' })
          }
        });
      }
      let dataList = []
      this.pastEvents = this.pastEvents;
      this.pastEvents.forEach(element => {
        dataList.push({
          video_thumbnail_image: element.stream_info ? element.stream_info.video_thumbnail_image : this.assets_url + "audio_default_image.png",
          slug: element.stream_info.slug,
          tag_category: "recorded-video",
          album: element.stream_info ? element.stream_info.stream_video_title : ""
        });
      });
      // this.getPastEventsList(dataList => {
      this.generList.push({
        data: dataList,
        id: -1,
        name: "Past Events",
        tag_category: "recorded-video",
        righthide: dataList.length > 4 ? true : false,
        count: dataList.length + 1,
        performer_id: this.performerInfo.user_id
      });
      // });

    });
    //console.log(this.generList)
  }
  navigatetoHome() {
    this.router.navigateByUrl('')
  }
  imageScroll() {
    (function HorizontalScrolling() {
      function wheelHandler(element, event) {
        const toLeft = event.deltaY < 0 && element.scrollLeft > 0
        const toRight = event.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth

        if (toLeft || toRight) {
          event.preventDefault()
          event.stopPropagation()

          element.scrollBy({ left: event.deltaY * 12 })
        }
      }

      const targets = document.querySelectorAll('#event-container')

      targets.forEach(element => element.addEventListener('wheel', event => wheelHandler(element, event)))
    })()
  }
  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 1250;
  }

  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += 1250;
  }
  leftscroll: boolean;
  divid: any;
  leftScroll(data, plan) {
    this.divid = 'gener' + data;
    document.getElementById('gener' + data).scrollLeft -= 400;
    if (document.getElementById('gener' + data).scrollLeft == 0) {
      plan.lefthide = false;

    }
    if (Math.abs(document.getElementById('gener' + data).scrollWidth) > (document.getElementById('gener' + data).scrollLeft + Math.abs(document.getElementById('gener' + data).offsetWidth))) {
      plan.righthide = true;
      plan.seeAll = true;
    }
    else {
      plan.lefthide = true;
    }

  }
  rightScroll(data, plan) {
    // let scroll =  document.getElementById('gener'+data).scrollLeft += 30;
    //console.log(document.getElementById('gener' + data).scrollLeft, Math.abs(document.getElementById('gener' + data).scrollWidth), Math.abs(document.getElementById('gener' + data).offsetWidth))
    document.getElementById('gener' + data).scrollLeft += 400;
    // let scrollLeftPrev = scroll + 30;
    if (document.getElementById('gener' + data).scrollLeft != 0) {
      plan.lefthide = true;
    }
    if (Math.abs(document.getElementById('gener' + data).scrollWidth) <= (document.getElementById('gener' + data).scrollLeft + Math.abs(document.getElementById('gener' + data).offsetWidth))) {
      plan.righthide = false;
    }
    else {
      plan.righthide = true;
    }
  }

  goTO() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Channel ${albumId} Subscribe Clicked ${userId}`);
    const data = {
      actionType: "network",
      metaData: {
        title: `Channel ${albumId} Subscribe Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      clickAction: 'subscribe'
    }
    this.commanSubscribeService.sendTriggeredEvent(data);
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.router.navigate([base + '/subscription-list/preview'], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      if (this.router.url.includes('/channel/')) {
        this.router.navigate([base + '/subscription-list/channel/' + this.settingsData.channelInfo.channel_name]);
        this.commanSubscribeService.getWebPageSettings(this.settingsData.channelInfo.channel_id);
      } else {
        this.router.navigate([base + '/subscription-list']);
        this.commanSubscribeService.getWebPageSettings(0);
      }
    }
  }
  goTOsticky() {
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.router.navigate([base + '/subscription-list/preview'], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      if (this.router.url.includes('/channel/')) {
        this.router.navigate([base + '/subscription-list/channel/' + this.settingsData.channelInfo.channel_name]);
        this.commanSubscribeService.getWebPageSettings(this.settingsData.channelInfo.channel_id);
      } else {
        this.router.navigate([base + '/subscription-list']);
        this.commanSubscribeService.getWebPageSettings(0);
      }
    }
  }

  goToGener(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Genre is clicked: ${data.tag_name || data.name} ${data.tag_id || data.id} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Genre is clicked: ${data.tag_name || data.name} ${data.tag_id || data.id}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      clickAction: 'genre-clicked'
    };
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    let id = data.tag_id ? data.tag_id : data.id;
    const itemGroup = data.network_group_id
      ? this.groups && this.groups.find((g: any) => g.id === data.network_group_id)
      : null;
    if (itemGroup) {
      this.commanSubscribeService.setActiveGroup(itemGroup);
      this.commanSubscribeService.getWebPageSettings(this.channelName, true);
    }
    const base = itemGroup
      ? `/${this.channelName}/${itemGroup.group_slug}`
      : this.commanSubscribeService.getChannelBasePath(this.channelName);
    // The View all page shows the genre's name in its header.
    const state = { genreName: data.tag_name || data.name };
    if (this.settingsData.is_preview) {
      this.router.navigate([base + "/" + data.tag_category + "/" + id + "/" + data.performer_id + "/preview"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token }, state });
    } else {
      if (this.router.url.includes('/channel/')) {
        this.router.navigate([base + "/channel/" + data.tag_category + "/" + id + "/" + data.performer_id + "/" + this.settingsData.channelInfo.channel_name], { state });
      } else {
        this.router.navigate([base + "/" + data.tag_category + "/" + id + "/" + data.performer_id], { state });
      }
    }
  }

  goToAlbum(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Album ${data.id} clicked - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${data.id} clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      networkGroupId : data?.network_group_id || null,

      clickAction: `album`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    const itemGroup = data.network_group_id
      ? this.groups && this.groups.find((g: any) => g.id === data.network_group_id)
      : null;
    this.commanSubscribeService.getWebPageSettings(this.channelName, true);
    if (itemGroup) {
      this.commanSubscribeService.setActiveGroup(itemGroup);
    }
    const base = this.commanSubscribeService.getChannelBasePath(this.channelName);
    if (this.settingsData.is_preview) {
      this.commanSubscribeService.albumBackHistory = base + "/album/" + data.tag_category + "/" + data.slug + "/preview";
      this.router.navigate([base + "/album/" + data.tag_category + "/" + data.slug + "/preview"], { queryParams: { token: this.activatedRoute.snapshot.queryParams.token } });
    } else {
      if (this.router.url.includes('/channel/')) {
        this.commanSubscribeService.albumBackHistory = base + "/album/channel/" + data.tag_category + "/" + data.slug;
        this.router.navigate([base + "/album/channel/" + data.tag_category + "/" + data.slug]);
        this.commanSubscribeService.getWebPageSettings(this.settingsData.channelInfo.channel_id);
      } else {
        this.commanSubscribeService.albumBackHistory = base + "/album/" + data.tag_category + "/" + data.slug;
        this.router.navigate([base + "/album/" + data.tag_category + "/" + data.slug]);
        this.commanSubscribeService.getWebPageSettings(0);
      }
    }
  }

  goToEvent(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const eventId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Event ${data.stream_info.id} clicked - ${userId}`)
    const u_payload = {
      actionType: "event",
      metaData: {
        title: `Event ${data.stream_info.id} clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      networkGroupId : data?.stream_info.network_group_id || null,

      clickAction: `event-type`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    if (!this.router.url.includes('/preview')) {
      // stream_info.group_slug can be stale vs the network's current group slug (which the
      // ChannelWebpageGuard validates against), so resolve the group by id first.
      const matchedGroup = this.groups && (
        this.groups.find((g: any) => data.stream_info.network_group_id && g.id === data.stream_info.network_group_id) ||
        this.groups.find((g: any) => data.stream_info.group_slug && g.group_slug === data.stream_info.group_slug)
      );
      if (matchedGroup) {
        this.commanSubscribeService.setActiveGroup(matchedGroup);
      }
      this.commanSubscribeService.getWebPageSettings(this.channelName, true);
      const baseEventUrl = matchedGroup
        ? `/${this.channelName}/${matchedGroup.group_slug}/event/${data.stream_info.slug}`
        : this.commanSubscribeService.getChannelBasePath(this.channelName) + '/event/' + data.stream_info.slug;
      if (data.affiliates && data.affiliates.length > 0 && data.ref_code) {
        let aff = data.affiliates.filter(a => a.referral_code == data.ref_code);
        if (aff.length > 0) {
          this.router.navigate([baseEventUrl], { queryParams: { ref: data.ref_code } });
        } else {
          this.router.navigate([baseEventUrl]);
        }
      } else {
        this.router.navigate([baseEventUrl]);
      }
    }
  }
  async getAds() {
    let allDiv = [];
    let count = 0;
    var temp_site_id = null;
    this.centerAds = [];
    //console.log('Stream page ads', this.streamAdsData);
    this.sponsorData = this.streamAdsData;
    var j = 0;
    var i = 1;
    var adTypeIdarr = [];
    var placements = [];
    j += 1;
    placements.push(
      {
        "divName": "div1",
        "networkId": Number(environment.kevel.NETWORK_ID),
        "siteId": this.org_info.vod_site_id,
        "advertiserId": this.org_info.advertiser_id,
        "adTypes": [4087],
      }
    );
    allDiv.push("div1");
    count = count + 1;
    // if (this.streamAdsData.length == count) {
    let data = {
      "placements": placements,
      "allDiv": allDiv
    };
    if (this.org_info.vod_site_id && this.org_info.advertiser_id) {
      //"?NOLOADER"
      this.commanSubscribeService.getAdsData(data, (err, result) => {
        if (result && result.status == 0 && result.Ads_data.length > 0) {
          //console.log(result.Ads_data,'test');
          result.Ads_data.forEach(element => {
            if (element.contents && element.contents[0] && element.contents[0].data.customData && element.contents[0].data.customData.ad_size == "850x150") {
              this.centerAds.push(element);
            }
          });
          if (this.centerAds.length > 0) {
            this.centerAdsCount = this.centerAds.length;
            this.centerRollAds(this.centerAds);
          }
        }
      });
    }
  }
  adVideoCenter: any;
  showAdCenter: boolean;
  centerAdsCount: number = 1;
  selectedAdCenterData: any;
  adsCenterCount = 0;
  async centerRollAds(centerAdsdata) {
    this.adsCenterCount = this.adsCenterCount + 1;
    this.centerAdsCount = (this.centerAdsCount - 1);
    this.selectedAdCenterData = centerAdsdata[this.centerAdsCount].clickUrl;

    let index = this.centerAdsCount;
    if (centerAdsdata[index].contents && centerAdsdata[index].contents[0] && centerAdsdata[index].contents[0].body) {
      let adType = centerAdsdata[index].contents[0];
      let customData = adType.data['customData'] ? adType.data['customData'] : {};

      this.adVideoCenter = this.sanitizer.bypassSecurityTrustHtml(adType.body);
      this.showAdCenter = true;
      if (customData && customData.minPlayTime && customData.maxPlayTime && (Number(customData.maxPlayTime) <= Number(customData.minPlayTime))) {
        customData.maxPlayTime = Number(customData.minPlayTime) + 1;
      }
      var minplayTime = customData.minPlayTime ? customData.minPlayTime : 10;
      var maxPlayTime = customData.maxPlayTime ? (customData.maxPlayTime * 1000) : 20000;

      this.setTimerAd(minplayTime, () => { });
      if (centerAdsdata[index].impressionUrl) {
        this.commanSubscribeService.countAdsImpressions(centerAdsdata[index].impressionUrl);
      }
      // setTimeout(() => {
      //   this.centerCloseAdd();
      // }, maxPlayTime);
    }
    this.loadscript();
  }


  loadscript() {
    $(document).ready(function () {
      $('.ad img').attr('alt', ' ');
      $('.ad img').attr('title', ' ');
    });
  }
  showSkip: boolean = false;
  secondsData: any;
  centerCloseAdd() {
    if (this.showSkip) {
      if (this.centerAdsCount > 0 && this.centerAds.length > 0) {
        this.centerRollAds(this.centerAds);
      } else {
        this.centerAdsCount = 0;
        this.adsCenterCount = 0;
        this.centerAds = [];
        this.closeButton = true;
        this.showAdCenter = false;
        this.showSkip = false;
        this.showTimer = false;
        //console.log("::::::::::::::::::: All ads gets skiped center");

      }
    }
  }

  setTimer(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = "Skip Ads";
        this.showSkip = true;
      } else {
        this.secondsData = "Skip Ads in " + (playTime - j);
      }
      this.showTimer = true;
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }
  setTimerAd(playTime, callback) {
    callback();
    let j = 0;
    this.showSkip = false;
    var interval = setInterval(() => {
      if (j >= playTime) {
        this.secondsData = " ";
        this.showSkip = true;
      } else {
        this.secondsData = " " + (playTime - j);
      }
      this.showTimer = true;
      // console.log("::::::::::::::::::: ", this.secondsData, typeof this.secondsData );
      if (j >= playTime) {
        clearInterval(interval);
      }
      j += 1;
    }, 1000);
  }
  getPastEventsList(callBack) {
    let videoParams = {
      "organization_id": this.org_info.id,
      "limit": 20
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: videoParams
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PAST_EVENTS, data).then(response => {
      this.ngxLoader.stop();
      let list = [];
      if (response.data.statusCode === '200') {
        this.pastEvents = response.data.Data;
        this.pastEvents.forEach(element => {
          list.push({
            video_thumbnail_image: element.stream_info ? element.stream_info.video_thumbnail_image : this.assets_url + "audio_default_image.png",
            slug: element.stream_info.slug,
            tag_category: "recorded-video",
            album: element.stream_info ? element.stream_info.stream_video_title : ""
          });
        });
      }
      callBack(list);
    }).catch(error => {
      this.ngxLoader.stop();
      callBack([]);
    });
  }

  videosList: any = [];
  getRecordedVideosList(callBack) {
    let videoParams = {
      // "channel_name": this.performerInfo.channel_name,
      "performerId": this.performerInfo.user_id,
      "orgId": this.org_info.id,
      "type": "video",
      "limit": 10
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: videoParams
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.PERFORMER_VIDEOS, data).then(response => {
      this.ngxLoader.stop();
      let list = [];
      if (response.data.statusCode === '200') {
        this.videosList = response.data.Data;
        this.videosList.forEach(element => {
          list.push({
            video_thumbnail_image: element.stream_info ? element.stream_info.video_thumbnail_image : this.assets_url + "audio_default_image.png",
            slug: element.slug,
            tag_category: "recorded-video",
            album: element.stream_info ? element.stream_info.stage : ""
          });
        });
      }
      callBack(list);
    }).catch(error => {
      this.ngxLoader.stop();
      callBack([]);
    });
  }


  ngAfterViewChecked() {
    this.resetGroupRowScroll();
    for (let i = 0; i < this.generList.length; i++) {
      this.changeDetector.detectChanges()
      if (this.generList[i].data.length > 0) {
        if (Math.abs(document.getElementById('gener' + i).scrollWidth) <= (document.getElementById('gener' + i).scrollLeft + Math.abs(document.getElementById('gener' + i).offsetWidth))) {
          this.generList[i].righthide = false;
        }
        if (Math.abs(document.getElementById('gener' + i).scrollWidth) > (document.getElementById('gener' + i).scrollLeft + Math.abs(document.getElementById('gener' + i).offsetWidth))) {
          this.generList[i].righthide = true;
        }
        if ((Math.abs(document.getElementById('gener' + i).scrollWidth) <= (document.getElementById('gener' + i).scrollLeft + Math.abs(document.getElementById('gener' + i).offsetWidth))) && ((Math.abs(document.getElementById('gener' + i).scrollWidth) == Math.abs(document.getElementById('gener' + i).offsetWidth)))) {
          this.generList[i].seeAll = false;
        }
        if ((Math.abs(document.getElementById('gener' + i).scrollWidth) > (document.getElementById('gener' + i).scrollLeft + Math.abs(document.getElementById('gener' + i).offsetWidth))) && ((Math.abs(document.getElementById('gener' + i).scrollWidth) != Math.abs(document.getElementById('gener' + i).offsetWidth)))) {
          this.generList[i].seeAll = true;
        }
        this.changeDetector.detectChanges()
      }
    }
  }

  goToChannel(subChannel) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Channel is clicked: ${subChannel.channel_name} ${subChannel.channel_id} - ${userId}`);
    const u_payload = {
      actionType: "community",
      metaData: {
        title: `Channel is clicked: ${subChannel.channel_name} ${subChannel.channel_id}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.org_id || null,
      networkGroupId : subChannel?.network_group_id || null,
      clickAction: 'channel-clicked'
    };
    this.commanSubscribeService.sendTriggeredEvent(u_payload);

    if (!this.router.url.includes('/preview')) {
      const itemGroup = subChannel.network_group_id
        ? this.groups && this.groups.find((g: any) => g.id === subChannel.network_group_id)
        : null;
      if (itemGroup) {
        this.commanSubscribeService.setActiveGroup(itemGroup);
      }
      const base = itemGroup
        ? `/${this.channelName}/${itemGroup.group_slug}`
        : this.commanSubscribeService.getChannelBasePath(this.channelName);
      this.router.navigate([base + '/channel/' + subChannel.channel_name]);
    }
  }


  seeAllChannels() {

  }

  leftScrollChannels() {
    document.getElementById('sub-channel-container').scrollLeft -= 400;
    if (document.getElementById('sub-channel-container').scrollLeft == 0) {
      this.showSubChannelLeftButton = false;
    } else {
      this.showSubChannelLeftButton = true;
    }
    if ((document.getElementById('sub-channel-container').scrollWidth) ==
      (document.getElementById('sub-channel-container').scrollLeft +
        document.getElementById('sub-channel-container').offsetWidth)) {
      this.showSubChannelRightButton = false
    } else {
      this.showSubChannelRightButton = true
    }
  }

  rightScrollChannels() {
    document.getElementById('sub-channel-container').scrollLeft += 400;
    if (document.getElementById('sub-channel-container').scrollLeft == 0) {
      this.showSubChannelLeftButton = false;
    } else {
      this.showSubChannelLeftButton = true;
    }
    if ((document.getElementById('sub-channel-container').scrollWidth) ==
      (document.getElementById('sub-channel-container').scrollLeft +
        document.getElementById('sub-channel-container').offsetWidth)) {
      this.showSubChannelRightButton = false
    } else {
      this.showSubChannelRightButton = true
    }
  }

  // A group only has its own separate plans when its own flag is on; otherwise it
  // inherits the network-level plan, so an existing network-level subscription should
  // still count as "subscribed" on that group's home page too. EXCEPT: if the channel
  // itself has its own dedicated plan (channelInfo.subscription == 1), that plan lives
  // inside the group's plan set (planGroupId == this.groupId) regardless of the group's
  // own flag.
  private shouldUseGroupPlans(activeGroup: any, channelInfo: any): boolean {
    const channelHasOwnPlan = !!(channelInfo && channelInfo.subscription == 1 && channelInfo.channel_id);
    return !!(activeGroup && (activeGroup.separate_subscription_plan == 1 || channelHasOwnPlan));
  }

  isSubscribed: boolean = false;
  checkIsSubscribed(plans) {
    this.isSubscribed = false;
    let cid;
    if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id)
      cid = this.settingsData.channelInfo.channel_id;

    if (this.router.url.includes('/channel/')) {
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.subscription == 0) {
        cid = 0;
      }
    }

    const activeGroup = this.groupId > 0 ? (this.groups || []).find(g => g.id === this.groupId) : null;
    const groupHasSeparatePlan = this.shouldUseGroupPlans(activeGroup, this.settingsData && this.settingsData.channelInfo);

    if (plans && plans.length > 0) {
      plans.forEach(element => {
        const planGroupId = this.planGroupMap.get(element.plan_id) || 0;
        const matchesGroup = groupHasSeparatePlan ? planGroupId == this.groupId : planGroupId == 0;
        if ((element.channel_id == cid || (!element.channel_id && !this.router.url.includes('/channel/'))) && element.payment == 'success' && matchesGroup) {
          this.isSubscribed = true;
        }
      });
    }
  }

  redirectTo() {
    if (!this.router.url.includes('/preview')) {
      this.router.navigateByUrl('/');
    }
  }
  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.performerInfoSubscr)
      this.performerInfoSubscr.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.browserButtonBackForwSubscription)
      this.browserButtonBackForwSubscription.unsubscribe();
    if (this.groupSyncOnNavSubscription)
      this.groupSyncOnNavSubscription.unsubscribe();
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - (currentScroll / 5));
      }
    })();
  }
}
